export enum CookieKeysEnum {
  token = 'token',
  refreshToken = 'refreshToken',
}

export enum CookieHeadersEnum {
  shouldSkipInterceptor = 'shouldSkipInterceptor'
}
